import { Navigate, useParams } from "react-router-dom";

/**
 * The old Hands Library routes.
 *
 * They render the PlayStudio agent catalogue, which is empty in workforce
 * mode, and the nav's "Workforce" entry used to point at them. Anyone with a
 * stale tab or an old bookmark therefore lands on "No agents yet" — a screen
 * that looks like a product with nothing in it, while the roster next door
 * has the agents and their runs.
 */
export function RedirectToWorkforce() {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  return <Navigate to={`/workspaces/${workspaceId ?? ""}/workforce`} replace />;
}
